import { EmploymentSchedule } from '../types/backendResponses/EmploymentSchedule';
import { weekDay } from '../types/weekDay';
import { translateDayToEnglish } from './translateDayToEnglish';

export const setDefaultStateScheduleCheckboxes = (
  weekDays: weekDay[],
  schedulesWeekDays: EmploymentSchedule
): boolean[] => {
  const matchedDay = [];

  for (let i = 0; i < weekDays.length; i++) {
    const weekDay = weekDays[i];
    for (let j = 0; j < schedulesWeekDays.employmentSchedule.length; j++) {
      const schedulesWeekDay = schedulesWeekDays.employmentSchedule[j];

      const translatedDay = translateDayToEnglish(weekDay.name);
      if (schedulesWeekDay.day === translatedDay) {
        matchedDay.push(true);
        break;
      } else if (i === j) {
        matchedDay.push(false);
      }
    }
  }

  return matchedDay;
};
